<template>
    <div class="container">
        <h1>My Events</h1>
        <div>
            <div v-for="event in events" class="w-100 row">
                <div class="col-sm">{{ event.name }}</div>
                <div class="col-sm" v-html="event.info"></div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { MyEvent } from '#imports';
import { useModyApi } from '~/middelware/ModyApi';


const api = useModyApi()
const events = ref<MyEvent[]>([])

onMounted(async ()=>{
    
    const response = await api.get("user/myEvents")

    response.data.forEach(element => {
        const newEvent = new MyEvent()
        const temp = {
            id:element.id,
            attributes:element
        }
        newEvent.parseJson(temp)
        events.value.push(newEvent)
    });
    console.log(events.value)
})

</script>